import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { LuPlus } from "react-icons/lu";
import { Loader } from "../components/ui/Loader";
import { ProjectsGrid } from "../components/shared/ProjectsGrid";
import { fetchOwnedProjects } from "../lib/projects";
import { PROJECT_STATUSES, PROJECT_STATUS_LABELS, Project, ProjectStatus } from "../models/project";

export const MyProjects = () => {
  const [projects, setProjects] = useState<Project[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [status, setStatus] = useState<"" | ProjectStatus>("");
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");

  useEffect(() => {
    fetchOwnedProjects()
      .then(setProjects)
      .catch((e) => setError(e instanceof Error ? e.message : "Помилка завантаження"))
      .finally(() => setLoading(false));
  }, []);

  const filtered = projects.filter((p) => {
    if (status && p.status !== status) return false;
    const day = p.submitted_at.slice(0, 10);
    if (dateFrom && day < dateFrom) return false;
    if (dateTo && day > dateTo) return false;
    return true;
  });

  return (
    <main className="mx-auto w-full max-w-cabinet flex-1 px-5 py-8 md:px-8">
      <div className="flex flex-col sm:flex-row gap-y-5 sm:items-center justify-between">
        <h1 className="text-2xl font-bold text-white">Мої проєкти</h1>
        <Link to="/submit" className="btn-brand w-full justify-center sm:w-auto px-5 py-3 text-xs whitespace-nowrap">
          <LuPlus className="text-xl" aria-hidden />
          Передати новий проєкт
        </Link>
      </div>

      {loading ? (
        <Loader />
          ) : error ? (
            <p className="mt-7 rounded border border-red-500/30 bg-red-500/10 px-4 py-3 text-sm text-red-400">
              {error}
            </p>
          ) : (
            <>
              <section className="mt-5 sm:card sm:p-5 sm:mt-7 grid grid-cols-1 sm:grid-cols-2 gap-x-3 sm:gap-4">
                <label className="block">
                  <span className="mb-2 block text-sm font-semibold text-neutral-300">
                    Статус
                  </span>
                  <select
                    className="input-dark"
                    value={status}
                    onChange={(e) => setStatus(e.target.value as "" | ProjectStatus)}
                  >
                    <option value="" className="text-black">Всі</option>
                    {PROJECT_STATUSES.map((s) => (
                      <option key={s} value={s} className="text-black">
                        {PROJECT_STATUS_LABELS[s]}
                      </option>
                    ))}
                  </select>
                </label>
                <div>
                  <span className="mb-2 block text-sm font-semibold text-neutral-300">
                    Період
                  </span>
                  <div className="flex">
                    <input
                      type="date"
                      value={dateFrom}
                      onChange={(e) => setDateFrom(e.target.value)}
                      className="w-1/2 input-dark rounded-r-none border-r-0"
                      aria-label="Дата з"
                    />
                    <input
                      type="date"
                      value={dateTo}
                      onChange={(e) => setDateTo(e.target.value)}
                      className="w-1/2 input-dark rounded-l-none"
                      aria-label="Дата по"
                    />
                  </div>
                </div>
              </section>
              {filtered.length === 0 ? (
                <p className="card mt-5 sm:mt-7 px-5 py-12 sm:p-12 text-center text-sm text-neutral-400">
                  Проєктів не знайдено
                </p>
              ) : (
                <section className="card mt-5 sm:mt-7 p-4 sm:p-6">
                  <ProjectsGrid projects={filtered} />
                </section>
              )}
            </>
          )}
    </main>
  );
};
